"use client";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import FaqSearch from "./FaqSearch";

export default function FaqSearchContainer() {
  const t = useTranslations();
  const searchParams = useSearchParams();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h2 className="text-lg font-semibold md:text-[44px]">
          {searchParams?.get("lang")
            ? t(`common.howCanWeHelpYou${searchParams?.get("lang")}`)
            : t("common.howCanWeHelpYou")}
        </h2>
        <p className="text-foreground-muted text-sm">
          {searchParams?.get("lang")
            ? t(
                `common.howCanWeHelpYouDescriptionApp${searchParams?.get("lang")}`,
              )
            : t("common.howCanWeHelpYouDescription")}
        </p>
      </div>

      <FaqSearch />
    </div>
  );
}
